var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("CustomizationSelector", {
        attrs: {
          title: "",
          value: _vm.item.name,
          options: _vm.accessoriesOptions,
          v: _vm.$v.item.name,
          error: _vm.$v.item.name.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.name = $event),
              _vm.getPrice(),
              (_vm.item.tubeType = null)
          }
        }
      }),
      _vm._v(" "),
      ["Somfy Sonesse 30 2.0nm"].includes(_vm.item.name)
        ? _c("v-select", {
            attrs: { items: _vm.tubes, label: "Tube Type" },
            model: {
              value: _vm.item.tubeType,
              callback: function($$v) {
                _vm.$set(_vm.item, "tubeType", $$v)
              },
              expression: "item.tubeType"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { type: "number", min: "1", label: "Quantity" },
        on: {
          input: function($event) {
            _vm.item.total = _vm.item.quantity * _vm.item.itemPrice
          }
        },
        model: {
          value: _vm.item.quantity,
          callback: function($$v) {
            _vm.$set(_vm.item, "quantity", $$v)
          },
          expression: "item.quantity"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "Item Price", readonly: "" },
        model: {
          value: _vm.item.itemPrice,
          callback: function($$v) {
            _vm.$set(_vm.item, "itemPrice", $$v)
          },
          expression: "item.itemPrice"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "Total", readonly: "" },
        model: {
          value: _vm.item.total,
          callback: function($$v) {
            _vm.$set(_vm.item, "total", $$v)
          },
          expression: "item.total"
        }
      }),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add " + _vm._s(_vm.item.type))]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          ),
      _vm._v(" "),
      _c("b", [_vm._v("$" + _vm._s(_vm.item.total.toFixed(2)))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c37b3f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c37b3f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/MotorAccessories.vue
// module id = null
// module chunks = 